import React, { createContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { apiUrl } from "../config/config";

import {
  getFromLocalStorage,
  removeFromLocalStorage,
} from "../utils/helperFunctions";
import Swal from "sweetalert2";
import {
  CART_COUNT_EVENT,
  CART_REFRESH_EVENT,
  normalizeCartCount,
  setCartCount,
} from "../utils/cartCount";


export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [userDataseller, setUserDataseller] = useState({});
  const [matchedSellerLogin, setMatchedSellerLogin] = useState(null);
  const [cartLength, setCartLength] = useState(
    normalizeCartCount(localStorage.getItem("cartLength"))
  );
  const [initialized, setInitialized] = useState(false);
  const loading = false;
  const [hasLoggedOut, setHasLoggedOut] = useState(false);

  const logintoken = localStorage.getItem("APP_TOKEN");
  const emailGuest = Cookies.get("Email_guest");

  // 🔹 Load user instantly from localStorage
  useEffect(() => {
    const storedId = getFromLocalStorage("Id");
    const storedEmail = getFromLocalStorage("Email");
    const storedName = getFromLocalStorage("Name");

    if (storedEmail && storedName && storedId) {
      setUserData({ id: storedId, email: storedEmail, name: storedName });
      setUserDataseller({
        id: storedId,
        email: storedEmail,
        name: storedName,
         pwd:"",
      });
    }

    setInitialized(true);
  }, []);

  // 🔹 Fetch latest user data (sync in background)
  useEffect(() => {
    const userId = getFromLocalStorage("Id");
    if (!userId || !logintoken) return;

fetch(`${apiUrl}/api/user_login/${userId}`, {
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${logintoken}`,
  },
})
  .then((res) => {
   if (res.status === 401) {
  Swal.fire({
    icon: "warning",
    title: "Session Expired",
    text: "Your login session has expired. Please log in again.",
    confirmButtonColor: "#3085d6",
    confirmButtonText: "OK",
    backdrop: true,
    allowOutsideClick: false,
  }).then(() => {
    localStorage.clear();
    window.location.href = "/login";
  });
  return;
}

    if (!res.ok) throw new Error("Failed to fetch user");
    return res.json();
  })
  .then((data) => {
    const account = Array.isArray(data) ? data[0] : data;
    if (account?.email) {
      localStorage.setItem("Email", account.email);
      if (account.name) localStorage.setItem("Name", account.name);
      const normalizedAccount = { ...account, id: account.id || userId };
      setUserData(normalizedAccount);
      setUserDataseller(normalizedAccount);
    }
  })
  .catch((err) => console.error("User fetch error:", err));

  }, [logintoken]);

  // 🔹 Fetch seller login info
  useEffect(() => {
    if (!userDataseller?.id) return;
    fetch(`${apiUrl}/api/sellers-login`)
      .then((res) => res.json())
      .then((data) => {
        const match = data.find(
          (seller) => seller.user_seller_id === userDataseller.id
        );
        if (match) setMatchedSellerLogin(match);
      })
      .catch((err) => console.error("Seller fetch error:", err));
  }, [userDataseller]);

useEffect(() => {
  const fetchCartLength = async () => {
    if (hasLoggedOut) {
      setCartLength(setCartCount(0));
      return;
    }

    const emailToFetch = userData?.email || emailGuest;
    if (!emailToFetch) {
      setCartLength(setCartCount(0));
      return;
    }

    // setLoading(true);
    try {
      const res = await fetch(`${apiUrl}/api/checkouts/email/${emailToFetch}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${logintoken}`,
        },
      });
      if (!res.ok) throw new Error("Failed to fetch cart");

      const data = await res.json();
      if (hasLoggedOut) {
        setCartLength(setCartCount(0));
        return;
      }

      let count = 0;
      if (Array.isArray(data)) count = data.length;
      else if (data && typeof data === "object" && Object.keys(data).length > 0)
        count = 1;

      setCartLength(setCartCount(count));
    } catch (err) {
      console.error("Cart fetch error:", err);
    } finally {
      // setLoading(true);
    }
  };

  // Fetch immediately
  fetchCartLength();

  // ✅ Also listen for storage changes (cart updates from other tabs or components)
  const handleStorageChange = (e) => {
    if (e.key === "cartLength") {
      setCartLength(hasLoggedOut ? 0 : normalizeCartCount(e.newValue));
    }
  };
  const handleCartCountChange = (e) => {
    setCartLength(hasLoggedOut ? 0 : normalizeCartCount(e.detail));
  };
  const handleCartRefresh = () => fetchCartLength();

  window.addEventListener("storage", handleStorageChange);
  window.addEventListener(CART_COUNT_EVENT, handleCartCountChange);
  window.addEventListener(CART_REFRESH_EVENT, handleCartRefresh);

  // ✅ Optional: auto-refresh cart every 15s
  const interval = setInterval(fetchCartLength, 15000);

  return () => {
    window.removeEventListener("storage", handleStorageChange);
    window.removeEventListener(CART_COUNT_EVENT, handleCartCountChange);
    window.removeEventListener(CART_REFRESH_EVENT, handleCartRefresh);
    clearInterval(interval);
  };
}, [userData?.email, emailGuest, logintoken, hasLoggedOut]);


  // 🔹 Logout handler
  const handleLogout = () => {
    setHasLoggedOut(true);
    removeFromLocalStorage("Id");
    removeFromLocalStorage("Email");
    removeFromLocalStorage("APP_TOKEN");
    removeFromLocalStorage("Name");
    localStorage.clear();
    setUserData(null);
    setUserDataseller({});
    setMatchedSellerLogin(null);
    setCartLength(setCartCount(0));
  };

  // Wait until context initialized
  if (!initialized) {
    return (
        <></>
    //   <div
    //     style={{
    //       textAlign: "center",
    //       padding: "20px",
    //       fontSize: "14px",
    //       color: "#888",
    //     }}
    //   >
    //     Loading user data...
    //   </div>
    );
  } 

  return (
    <UserContext.Provider
      value={{
        userData,
        userDataseller,
        matchedSellerLogin,
        cartLength,
        logintoken,
        handleLogout,
        loading,
        setUserData, // ✅ exposed for instant update from login
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
